<template>
  <div>
    <BlockHeader name="RP Trade / E-Mail notifications" />
    <div class="row">
      <div class="col-lg-12 col-sm-12 col-xs-12 p-0">
        <div class="col-lg-6 col-sm-12 col-xs-12">
          <Input
            v-model="settingsLocal.email_sender"
            form-group-id="Sender"
            placeholder="Sender"
          />
        </div>
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input
          v-model="settingsLocal.email_recipient"
          form-group-id="Recipient"
          placeholder="Recipient"
        />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input
          v-model="settingsLocal.email_cc"
          form-group-id="CC"
          placeholder="CC's"
        />
      </div>
      <div class="col-lg-12 col-sm-12 col-xs-12">
        <Input
          v-model="settingsLocal.email_subject"
          form-group-id="Subject"
          placeholder="Subject"
        />
      </div>
      <div class="col-lg-12 col-sm-12 col-xs-12">
        <Textarea
          v-model="settingsLocal.email_text"
          form-group-id="E-Mail Text"
          placeholder="E-Mail Text"
        />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input
          v-model="settingsLocal.email_newclientsform_recipient"
          form-group-id="New Client Form Recipient"
          placeholder="New Client Form Recipient"
          :tile-size="11"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Textarea from '../../../../../common/textarea/index';
import Input from '../../../../../common/input/index';
import BlockHeader from '../../../../../common/block-header';

export default {
  name: 'Email',
  components: { Input, BlockHeader, Textarea },
  props: {
    settings: {
      type: Object,
      default: () => {}
    }
  },
  data: function() {
    return {};
  },
  computed: {
    settingsLocal: {
      get: function() {
        return this.settings;
      },
      set: function(value) {
        this.$emit('settings', value);
      }
    }
  }
};
</script>
